module.exports = __webpack_public_path__ + "static/img/anB_5.382e253.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/anB_5.png
// module id = 1252
// module chunks = 1